// ======================================
// Sample Data for NammaVeetuInteriors
// ======================================

// Services Data
export const services = [
    {
        slug: 'modular-kitchen',
        title: 'Modular Kitchen',
        description: 'Custom-designed modular kitchens with premium finishes, smart storage solutions, and modern appliances.',
        image: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=600&h=400&fit=crop',
        fullDescription: 'Transform your cooking space with our expertly designed modular kitchens. We combine functionality with aesthetics to create kitchens that are a joy to cook in.',
        highlights: ['Space optimization', 'Premium hardware', '10-year warranty', '45-day delivery'],
        priceRange: '₹2.5L - ₹8L',
        timeline: '30-45 days'
    },
    {
        slug: 'wardrobe',
        title: 'Wardrobes & Storage',
        description: 'Maximize your storage with beautifully designed wardrobes, walk-in closets, and smart storage solutions.',
        image: 'https://images.unsplash.com/photo-1558997519-83ea9252edf8?w=600&h=400&fit=crop',
        fullDescription: 'Our custom wardrobes are designed to maximize every inch of your space while keeping your belongings organized and accessible.',
        highlights: ['Custom designs', 'Soft-close hinges', 'LED lighting', 'Multiple finishes'],
        priceRange: '₹80K - ₹3L',
        timeline: '20-30 days'
    },
    {
        slug: 'living-room',
        title: 'Living Room Design',
        description: 'Create stunning living spaces with custom TV units, false ceilings, and elegant furniture solutions.',
        image: 'https://images.unsplash.com/photo-1618219908412-a29a1bb7b86e?w=600&h=400&fit=crop',
        fullDescription: 'Your living room is where memories are made. We design spaces that reflect your personality while providing comfort and functionality.',
        highlights: ['Custom TV units', 'False ceiling', 'Accent walls', 'Smart lighting'],
        priceRange: '₹1.5L - ₹5L',
        timeline: '25-35 days'
    },
    {
        slug: 'bedroom',
        title: 'Bedroom Interiors',
        description: 'Design your dream bedroom with custom beds, study tables, and personalized decor elements.',
        image: 'https://images.unsplash.com/photo-1616594039964-ae9021a400a0?w=600&h=400&fit=crop',
        fullDescription: 'Create a personal sanctuary with our bedroom designs. From luxurious master bedrooms to cozy kids rooms, we design spaces that inspire rest and relaxation.',
        highlights: ['Custom bed designs', 'Study corners', 'Ambient lighting', 'Premium finishes'],
        priceRange: '₹1L - ₹4L',
        timeline: '20-30 days'
    },
    {
        slug: 'bathroom',
        title: 'Bathroom Renovation',
        description: 'Modern bathroom designs with premium fixtures, smart storage, and luxury finishes.',
        image: 'https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=600&h=400&fit=crop',
        fullDescription: 'Transform your bathroom into a spa-like retreat. We handle everything from tiles to fixtures, creating a cohesive and luxurious space.',
        highlights: ['Premium fixtures', 'Waterproofing', 'Storage solutions', 'Modern tiles'],
        priceRange: '₹1L - ₹3L',
        timeline: '15-25 days'
    },
    {
        slug: 'full-home',
        title: 'Full Home Interiors',
        description: 'Complete home transformation with cohesive design language across all spaces.',
        image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=600&h=400&fit=crop',
        fullDescription: 'Get the complete package with our full home interior solutions. We create a cohesive design language that flows through every room.',
        highlights: ['End-to-end design', 'Project manager', 'Quality checks', 'Warranty coverage'],
        priceRange: '₹8L - ₹25L+',
        timeline: '60-90 days'
    }
];

// Packages Data
export const packages = [
    {
        type: '2BHK',
        name: 'Essential',
        price: '4.5',
        features: [
            { name: 'Modular Kitchen', included: true },
            { name: '2 Wardrobes', included: true },
            { name: 'TV Unit', included: true },
            { name: 'Shoe Rack', included: true },
            { name: 'Crockery Unit', included: false },
            { name: 'False Ceiling', included: false },
            { name: 'Painting', included: false }
        ]
    },
    {
        type: '2BHK',
        name: 'Premium',
        price: '6.5',
        features: [
            { name: 'Modular Kitchen', included: true },
            { name: '2 Wardrobes', included: true },
            { name: 'TV Unit', included: true },
            { name: 'Shoe Rack', included: true },
            { name: 'Crockery Unit', included: true },
            { name: 'False Ceiling', included: true },
            { name: 'Painting', included: false }
        ]
    },
    {
        type: '3BHK',
        name: 'Luxe',
        price: '9.5',
        features: [
            { name: 'Modular Kitchen', included: true },
            { name: '3 Wardrobes', included: true },
            { name: 'TV Unit', included: true },
            { name: 'Shoe Rack', included: true },
            { name: 'Crockery Unit', included: true },
            { name: 'False Ceiling', included: true },
            { name: 'Painting', included: true }
        ]
    }
];

// Projects Data
export const projects = [
    {
        slug: 'modern-minimalist-anna-nagar',
        title: 'Modern Minimalist Home',
        bhk: '3 BHK',
        location: 'Anna Nagar',
        image: 'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=600&h=400&fit=crop',
        beforeImage: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=500&fit=crop',
        afterImage: 'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=800&h=500&fit=crop',
        budget: '₹12 Lakhs',
        duration: '45 days',
        rooms: ['Living Room', 'Kitchen', 'Master Bedroom', '2 Bedrooms'],
        description: 'A complete transformation of a dated 3BHK into a modern minimalist haven. Clean lines, neutral tones, and smart storage solutions define this project.'
    },
    {
        slug: 'cozy-apartment-velachery',
        title: 'Cozy Family Apartment',
        bhk: '2 BHK',
        location: 'Velachery',
        image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=600&h=400&fit=crop',
        beforeImage: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=500&fit=crop',
        afterImage: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&h=500&fit=crop',
        budget: '₹6.5 Lakhs',
        duration: '35 days',
        rooms: ['Living Room', 'Kitchen', 'Master Bedroom', 'Kids Room'],
        description: 'Warm colors and family-friendly design for a young couple with children. Focus on durability and easy maintenance.'
    },
    {
        slug: 'luxury-villa-ecr',
        title: 'Luxury Beach Villa',
        bhk: '4 BHK Villa',
        location: 'ECR',
        image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=600&h=400&fit=crop',
        beforeImage: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=500&fit=crop',
        afterImage: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&h=500&fit=crop',
        budget: '₹28 Lakhs',
        duration: '75 days',
        rooms: ['Living Area', 'Kitchen', 'Master Suite', '3 Bedrooms', 'Home Office'],
        description: 'Premium villa interiors with ocean-inspired themes. Custom furniture, Italian marble, and smart home integration throughout.'
    },
    {
        slug: 'compact-studio-omr',
        title: 'Compact Studio Home',
        bhk: '1 BHK',
        location: 'OMR',
        image: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=600&h=400&fit=crop',
        beforeImage: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=500&fit=crop',
        afterImage: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800&h=500&fit=crop',
        budget: '₹3.5 Lakhs',
        duration: '25 days',
        rooms: ['Living + Bedroom', 'Kitchen', 'Bathroom'],
        description: 'Smart space utilization for a young professional. Multi-functional furniture and clever storage maximize every square foot.'
    },
    {
        slug: 'traditional-modern-t-nagar',
        title: 'Traditional Meets Modern',
        bhk: '3 BHK',
        location: 'T. Nagar',
        image: 'https://images.unsplash.com/photo-1600210491892-03d54c0aaf87?w=600&h=400&fit=crop',
        beforeImage: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=500&fit=crop',
        afterImage: 'https://images.unsplash.com/photo-1600210491892-03d54c0aaf87?w=800&h=500&fit=crop',
        budget: '₹14 Lakhs',
        duration: '50 days',
        rooms: ['Living Room', 'Pooja Room', 'Kitchen', 'Master Bedroom', '2 Bedrooms'],
        description: 'Blending traditional South Indian aesthetics with contemporary design. Custom woodwork and brass accents throughout.'
    },
    {
        slug: 'bachelor-pad-adyar',
        title: 'Modern Bachelor Pad',
        bhk: '2 BHK',
        location: 'Adyar',
        image: 'https://images.unsplash.com/photo-1600607687644-c7171b42498f?w=600&h=400&fit=crop',
        beforeImage: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=500&fit=crop',
        afterImage: 'https://images.unsplash.com/photo-1600607687644-c7171b42498f?w=800&h=500&fit=crop',
        budget: '₹5.5 Lakhs',
        duration: '30 days',
        rooms: ['Open Living', 'Kitchen Bar', 'Master Bedroom', 'Guest Room'],
        description: 'Bold, contemporary design for a young tech professional. Dark tones, industrial accents, and entertainment-focused layout.'
    }
];

// Testimonials Data
export const testimonials = [
    {
        name: 'Priya Sharma',
        avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop',
        project: '3BHK, Anna Nagar',
        quote: 'NammaVeetuInteriors transformed our house into a dream home. The attention to detail and quality of work exceeded our expectations. Highly recommend!'
    },
    {
        name: 'Rajesh Kumar',
        avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop',
        project: '2BHK, Velachery',
        quote: 'Transparent pricing, no hidden costs, and they delivered exactly on time. The team was professional throughout the project. Very happy with our new kitchen!'
    },
    {
        name: 'Anitha Venkat',
        avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop',
        project: 'Villa, ECR',
        quote: 'Working with NVI was a breeze. They understood our requirements perfectly and the final result is stunning. Our friends can\'t stop complimenting our interiors!'
    },
    {
        name: 'Suresh Babu',
        avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop',
        project: '3BHK, T. Nagar',
        quote: 'The 10-year warranty gives peace of mind. It\'s been 2 years and everything still looks and works like new. Best investment we made for our home.'
    }
];

// Design Styles
export const designStyles = [
    { name: 'Modern Minimalist', image: 'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=300&h=200&fit=crop' },
    { name: 'Contemporary', image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=300&h=200&fit=crop' },
    { name: 'Traditional', image: 'https://images.unsplash.com/photo-1600210491892-03d54c0aaf87?w=300&h=200&fit=crop' },
    { name: 'Industrial', image: 'https://images.unsplash.com/photo-1600607687644-c7171b42498f?w=300&h=200&fit=crop' }
];

// How It Works Steps
export const howItWorksSteps = [
    {
        number: 1,
        title: 'Book Free Consultation',
        description: 'Share your requirements and we\'ll send our design expert to your home for a free consultation.'
    },
    {
        number: 2,
        title: 'Get Custom Designs',
        description: 'Receive 3D designs and detailed quotes within 7 days. Revise until you\'re 100% satisfied.'
    },
    {
        number: 3,
        title: 'Confirm & Pay',
        description: 'Review the final design, confirm the scope, and make the initial payment to begin work.'
    },
    {
        number: 4,
        title: 'Manufacturing & Delivery',
        description: 'We manufacture at our factory and deliver directly to your home. Quality checked at every step.'
    },
    {
        number: 5,
        title: 'Installation & Handover',
        description: 'Our expert team installs everything. Final walkthrough and handover with 10-year warranty.'
    }
];

// Why Choose Us
export const whyChooseUs = [
    {
        icon: 'shield',
        title: '10-Year Warranty',
        description: 'Industry-leading warranty covering materials and workmanship for complete peace of mind.'
    },
    {
        icon: 'clock',
        title: '45-Day Delivery',
        description: 'Guaranteed delivery timelines or we pay the penalty. No delays, no excuses.'
    },
    {
        icon: 'calculator',
        title: 'Transparent Pricing',
        description: 'No hidden costs. Get detailed quotes upfront with itemized pricing for everything.'
    },
    {
        icon: 'award',
        title: '500+ Happy Homes',
        description: 'Join hundreds of satisfied families who trusted us with their dream interiors.'
    }
];

// Estimator Pricing (per sq ft or base pricing)
export const estimatorPricing = {
    rooms: {
        kitchen: { base: 150000, name: 'Modular Kitchen' },
        wardrobe: { base: 45000, name: 'Wardrobe' },
        tvUnit: { base: 35000, name: 'TV Unit' },
        falseCeiling: { base: 25000, name: 'False Ceiling' },
        painting: { base: 20000, name: 'Painting' },
        bathroom: { base: 50000, name: 'Bathroom' },
        studyTable: { base: 15000, name: 'Study Table' },
        shoeCabinet: { base: 12000, name: 'Shoe Cabinet' }
    },
    finishMultiplier: {
        essential: 1,
        premium: 1.3,
        luxe: 1.6
    },
    bhkMultiplier: {
        '1bhk': 0.7,
        '2bhk': 1,
        '3bhk': 1.4,
        '4bhk': 1.8
    }
};

// ======================================
// Phase 2 Data
// ======================================

// Materials & Brands Data
export const materials = [
    {
        category: 'Plywood & Core',
        items: [
            { name: 'Century Ply', type: 'BWP Grade', warranty: '25 Years', image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=200&h=150&fit=crop' },
            { name: 'Greenply', type: 'BWP Grade', warranty: '20 Years', image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=200&h=150&fit=crop' },
            { name: 'Archid', type: 'MR Grade', warranty: '15 Years', image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=200&h=150&fit=crop' }
        ]
    },
    {
        category: 'Hardware',
        items: [
            { name: 'Hettich', type: 'German Engineering', warranty: 'Lifetime', image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=200&h=150&fit=crop' },
            { name: 'Hafele', type: 'Premium Fittings', warranty: 'Lifetime', image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=200&h=150&fit=crop' },
            { name: 'Blum', type: 'Austrian Quality', warranty: 'Lifetime', image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=200&h=150&fit=crop' }
        ]
    },
    {
        category: 'Finishes',
        items: [
            { name: 'Merino Laminate', type: '1mm Laminate', warranty: '7 Years', image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=200&h=150&fit=crop' },
            { name: 'Greenlam', type: 'Premium Laminate', warranty: '7 Years', image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=200&h=150&fit=crop' },
            { name: 'Acrylic Finish', type: 'High Gloss', warranty: '10 Years', image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=200&h=150&fit=crop' },
            { name: 'PU Finish', type: 'Premium Paint', warranty: '10 Years', image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=200&h=150&fit=crop' }
        ]
    },
    {
        category: 'Appliances',
        items: [
            { name: 'Faber', type: 'Chimneys & Hobs', warranty: '5 Years', image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=200&h=150&fit=crop' },
            { name: 'Elica', type: 'Kitchen Appliances', warranty: '5 Years', image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=200&h=150&fit=crop' },
            { name: 'Kaff', type: 'Built-in Appliances', warranty: '5 Years', image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=200&h=150&fit=crop' }
        ]
    }
];

// Locations Data (for local SEO)
export const locations = [
    {
        slug: 'chennai',
        name: 'Chennai',
        areas: ['Anna Nagar', 'T. Nagar', 'Velachery', 'Adyar', 'OMR', 'ECR', 'Porur', 'Guindy'],
        projectCount: 350,
        phone: '+91 82205 95978',
        address: '123 Design Street, Anna Nagar, Chennai - 600040',
        mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3886.0080692193045!2d80.20967431482225!3d13.085508090776044!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5265ea4f7d3361%3A0x6e61a70b6863d433!2sAnna%20Nagar%2C%20Chennai%2C%20Tamil%20Nadu!5e0!3m2!1sen!2sin!4v1640000000000!5m2!1sen!2sin',
        image: 'https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=600&h=400&fit=crop'
    },
    {
        slug: 'coimbatore',
        name: 'Coimbatore',
        areas: ['RS Puram', 'Gandhipuram', 'Peelamedu', 'Saibaba Colony', 'Race Course'],
        projectCount: 85,
        phone: '+91 98765 43211',
        address: '45 Interior Lane, RS Puram, Coimbatore - 641002',
        mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d125323.23847882019!2d76.88271839414695!3d11.01180247626689!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba859af2f971cb5%3A0x2fc1c81e183ed282!2sCoimbatore%2C%20Tamil%20Nadu!5e0!3m2!1sen!2sin!4v1640000000001!5m2!1sen!2sin',
        image: 'https://images.unsplash.com/photo-1570168007204-dfb528c6958f?w=600&h=400&fit=crop'
    },
    {
        slug: 'bangalore',
        name: 'Bangalore',
        areas: ['Whitefield', 'Koramangala', 'Indiranagar', 'HSR Layout', 'Marathahalli', 'Electronic City'],
        projectCount: 120,
        phone: '+91 98765 43212',
        address: '78 Tech Park Road, Whitefield, Bangalore - 560066',
        mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d248849.84916296514!2d77.49085452149516!3d12.954517010977897!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae1670c9b44e6d%3A0xf8dfc3e8517e4fe0!2sBengaluru%2C%20Karnataka!5e0!3m2!1sen!2sin!4v1640000000002!5m2!1sen!2sin',
        image: 'https://images.unsplash.com/photo-1596176530529-78163a4f7af2?w=600&h=400&fit=crop'
    }
];

// Team Data (for About page)
export const team = [
    {
        name: 'Arun Kumar',
        role: 'Founder & Lead Designer',
        bio: '15+ years in interior design. Trained at NID Ahmedabad. Passionate about creating functional yet beautiful spaces.',
        image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=300&h=300&fit=crop'
    },
    {
        name: 'Priya Venkatesh',
        role: 'Creative Director',
        bio: 'Expert in contemporary and traditional fusion designs. 10+ years experience with premium residential projects.',
        image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=300&h=300&fit=crop'
    },
    {
        name: 'Karthik Rajan',
        role: 'Operations Head',
        bio: 'Ensures every project is delivered on time. 12+ years in project management and client relations.',
        image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300&h=300&fit=crop'
    },
    {
        name: 'Meera Krishnan',
        role: 'Senior Designer',
        bio: 'Specializes in modular kitchens and storage solutions. Known for maximizing space in compact homes.',
        image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=300&h=300&fit=crop'
    }
];

// Company Values
export const companyValues = [
    { title: 'Quality First', description: 'We never compromise on materials or workmanship. Every project meets our rigorous quality standards.', icon: 'award' },
    { title: 'Transparency', description: 'No hidden costs, no surprises. You know exactly what you\'re paying for from day one.', icon: 'shield' },
    { title: 'On-Time Delivery', description: 'We respect your time. Our 45-day delivery guarantee keeps us accountable.', icon: 'clock' },
    { title: 'Customer Focus', description: 'Your satisfaction is our success. We design for your lifestyle, not just aesthetics.', icon: 'users' }
];

// Blog Posts Data
export const blogPosts = [
    {
        slug: 'modular-kitchen-trends-2024',
        title: '10 Modular Kitchen Trends for 2024',
        excerpt: 'Discover the latest kitchen design trends that combine style with functionality. From handleless cabinets to smart storage solutions.',
        category: 'Kitchen',
        author: 'Priya Venkatesh',
        date: '2024-01-15',
        readTime: '5 min',
        image: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=600&h=400&fit=crop',
        featured: true
    },
    {
        slug: 'small-space-wardrobe-ideas',
        title: 'Wardrobe Ideas for Small Bedrooms',
        excerpt: 'Maximize storage in compact spaces with clever wardrobe designs. Tips from our design experts on making the most of every inch.',
        category: 'Bedroom',
        author: 'Meera Krishnan',
        date: '2024-01-10',
        readTime: '4 min',
        image: 'https://images.unsplash.com/photo-1558997519-83ea9252edf8?w=600&h=400&fit=crop',
        featured: true
    },
    {
        slug: 'interior-design-budget-guide',
        title: 'Complete Guide to Interior Design Budget',
        excerpt: 'How much should you spend on home interiors? Our comprehensive guide helps you plan your budget wisely.',
        category: 'Guide',
        author: 'Arun Kumar',
        date: '2024-01-05',
        readTime: '8 min',
        image: 'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=600&h=400&fit=crop',
        featured: false
    },
    {
        slug: 'living-room-color-schemes',
        title: 'Best Color Schemes for Living Rooms',
        excerpt: 'From earthy neutrals to bold accents, discover color combinations that transform your living space.',
        category: 'Living Room',
        author: 'Priya Venkatesh',
        date: '2023-12-28',
        readTime: '6 min',
        image: 'https://images.unsplash.com/photo-1618219908412-a29a1bb7b86e?w=600&h=400&fit=crop',
        featured: false
    },
    {
        slug: 'choosing-right-plywood',
        title: 'How to Choose the Right Plywood',
        excerpt: 'BWP, MR, or Commercial? Understand plywood grades and make informed decisions for your furniture.',
        category: 'Materials',
        author: 'Karthik Rajan',
        date: '2023-12-20',
        readTime: '7 min',
        image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&h=400&fit=crop',
        featured: false
    },
    {
        slug: 'false-ceiling-designs',
        title: 'Modern False Ceiling Designs',
        excerpt: 'Explore POP, gypsum, and wooden false ceiling options. Find the perfect design for your home.',
        category: 'Living Room',
        author: 'Meera Krishnan',
        date: '2023-12-15',
        readTime: '5 min',
        image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=600&h=400&fit=crop',
        featured: false
    }
];

// Extended testimonials for dedicated page
export const extendedTestimonials = [
    ...testimonials,
    {
        name: 'Lakshmi Narayanan',
        avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100&h=100&fit=crop',
        project: '2BHK, OMR',
        quote: 'As first-time homeowners, we had so many questions. The NVI team was patient and guided us through every decision. Our 2BHK looks like a model home now!',
        rating: 5,
        videoUrl: null
    },
    {
        name: 'Vikram & Deepa',
        avatar: 'https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?w=100&h=100&fit=crop',
        project: '3BHK, Adyar',
        quote: 'We loved the 3D designs - it helped us visualize everything before work started. The final result was exactly what we saw in the renders. Amazing!',
        rating: 5,
        videoUrl: null
    },
    {
        name: 'Meenakshi Sundaram',
        avatar: 'https://images.unsplash.com/photo-1489424731084-a5d8b219a5bb?w=100&h=100&fit=crop',
        project: 'Villa, Thiruvanmiyur',
        quote: 'Our villa renovation was a big project. NVI handled it professionally from start to finish. The project manager kept us updated throughout. Highly impressed!',
        rating: 5,
        videoUrl: null
    },
    {
        name: 'Ramesh Balaji',
        avatar: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=100&h=100&fit=crop',
        project: '4BHK, Besant Nagar',
        quote: 'The modular kitchen they designed is a dream to cook in. Every inch is utilized perfectly. My wife is thrilled with the soft-close drawers!',
        rating: 5,
        videoUrl: null
    }
];

// Header Menu Data (Mega Menu)
export const headerMenuData = {
    designIdeas: {
        title: 'Design Ideas',
        categories: [
            {
                name: 'Modular Kitchen',
                items: ['Straight Kitchen', 'L-Shaped Kitchen', 'U-Shaped Kitchen', 'Parallel Kitchen', 'Island Kitchen', 'Acrylic Kitchens', 'PVC Kitchens']
            },
            {
                name: 'Wardrobe',
                items: ['Sliding Wardrobe', 'Swing Door Wardrobe', 'Walk-in Closet', 'Floor to Ceiling', 'With Mirror', 'Loft Wardrobes']
            },
            {
                name: 'Living Room',
                items: ['TV Units', 'False Ceiling', 'Wall Design', 'Sofa Designs', 'Partition Designs', 'Foyers', 'Pooja Units']
            },
            {
                name: 'Bedroom',
                items: ['Master Bedroom', 'Kids Bedroom', 'Guest Bedroom', 'Bed Back Design', 'Study Tables', 'Dressing Units']
            },
            {
                name: 'Space Saving',
                items: ['Foldable Beds', 'Hidden Storage', 'Multi-functional Furniture', 'Compact Dining']
            }
        ]
    },
    cities: [
        'Chennai',
        'Coimbatore',
        'Bangalore',
        'Madurai',
        'Trichy',
        'Salem',
        'Erode',
        'Vellore'
    ],
    more: [
        { name: 'About Us', link: '/about' },
        { name: 'Refer a Friend', link: '/refer' },
        { name: 'Careers', link: '/careers' },
        { name: 'Partner with Us', link: '/partner' },
        { name: 'Contact Support', link: '/contact' }
    ]
};
